// import { useCallback, useEffect, useMemo, useState } from "react";
// import { useParams } from "react-router-dom";
// import { useAxios } from "./axios";
// import api, { Room } from "./api-new.ts";
import { useContext } from "react";
import { GlobalContext } from "../components/GlobalContext";

export const useEvent = () => {
  const context = useContext(GlobalContext);
  return [context.eventViewer, context.setEventViewer] as const;
};

// export const useEvent = () => {
//   const params = useParams();
//   const roomId = useMemo(() => {
//     return params.id!;
//   }, [params.id]);

//   const axios = useAxios();
//   const getRoom = api.useGetRoom(axios);
//   const [event, setEvent] = useState<Room | undefined>();
//   const getEvent = useCallback(async () => {
//     const response = await api.getEvent({ roomId: roomId });
//     setEvent(response.data.event);
//   }, [roomId, setEvent]);
//   useEffect(() => {
//     getEvent();
//   }, [getEvent]);

//   return [event, setEvent] as const;
// };

export const useTrialEnded = () => {
  return false;
  // const [event] = useEvent();
  // const [trialSecondsRemaining, setTrialSecondsRemaining] = useState<
  //   number | null
  // >(null);
  // useEffect(() => {
  //   if (event) {
  //     setTrialSecondsRemaining(event.trial_seconds_remaining);
  //   }
  // }, [event]);

  // useEffect(() => {
  //   if (event && event.trial_seconds_remaining !== null) {
  //     const getSecondsRemainingInterval = setInterval(async () => {
  //       const response = await api.getEvent({ roomId: event.room_id });
  //       setTrialSecondsRemaining(response.data.event.trial_seconds_remaining);
  //       if (
  //         response.data.event.trial_seconds_remaining !== null &&
  //         response.data.event.trial_seconds_remaining <= 0
  //       ) {
  //         clearInterval(getSecondsRemainingInterval);
  //       }
  //     }, 30 * 1000);

  //     return () => {
  //       clearInterval(getSecondsRemainingInterval);
  //     };
  //   }
  // }, [event]);

  // const trialEnded = useMemo(() => {
  //   if (!event || !event.trial) {
  //     return false;
  //   }
  //   return trialSecondsRemaining !== null && trialSecondsRemaining <= 0;
  // }, [event, trialSecondsRemaining]);

  // return trialEnded;
};
